import { PROPERTIES, DEFAULT_TABLE_COLUMN_SIZES } from 'FormsUI/components/dashboard/frameworkTable/constants';
import { name } from 'FormsUI/components/dashboard/frameworkTable/CustomColumn/name';
import { dateTimeCell } from 'FormsUI/components/dashboard/frameworkTable/CustomColumn/dateTimeCell';
import { submissionRate } from 'FormsUI/components/dashboard/frameworkTable/CustomColumn/submissionRate';
import { submissions } from 'FormsUI/components/dashboard/frameworkTable/CustomColumn/submissions';
import { views } from 'FormsUI/components/dashboard/frameworkTable/CustomColumn/views';
import { appearsOn } from 'FormsUI/components/dashboard/frameworkTable/CustomColumn/appearsOn';
import { spamSubmissions } from 'FormsUI/components/dashboard/frameworkTable/CustomColumn/spamSubmissions';
import { status } from 'FormsUI/components/dashboard/frameworkTable/CustomColumn/status';
import { userCell } from 'FormsUI/components/dashboard/frameworkTable/CustomColumn/userCell';
const propertyToCustomTableColumn = {
  [PROPERTIES.NAME]: name,
  [PROPERTIES.LAST_MODIFIED_DATE]: dateTimeCell,
  [PROPERTIES.CREATED_BY_USER_ID]: userCell,
  [PROPERTIES.CREATED_AT]: dateTimeCell,
  [PROPERTIES.UPDATED_AT]: dateTimeCell,
  [PROPERTIES.UPDATED_BY_USER_ID]: userCell,
  [PROPERTIES.SUBMISSION_RATE]: submissionRate,
  [PROPERTIES.SUBMISSIONS]: submissions,
  [PROPERTIES.SPAM_SUBMISSIONS]: spamSubmissions,
  [PROPERTIES.VIEWS]: views,
  [PROPERTIES.FORM_ID]: appearsOn,
  [PROPERTIES.STATUS]: status
};
const CustomColumn = ({
  columnId
}) => {
  const property = columnId;
  const customTableColumn = propertyToCustomTableColumn[property];
  return customTableColumn ? Object.assign({}, DEFAULT_TABLE_COLUMN_SIZES, customTableColumn) : null;
};
export default CustomColumn;